import 'leaflet/dist/leaflet.css';
import './App.css';
import MapWidget from './MapWidget';

function App() {
  return (
    <div className="app">
      <MapWidget />
    </div>
  );
}

export default App;